import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import '../css/careerOpportunities.css';
import { formatDate } from '../../../../format/formatDate';
import Pagination from '../../../compoment/Pagination';
import { Store } from '../../../../Store';

const CareerOpportunities = ({ posts, setPageIndex }) => {
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);

  const [keyword, setKeyword] = useState('');

  const handleDetail = (url) => {
    const breadcrumb = [
      {
        title: 'Tuyển dụng',
        slug: 'tuyen-dung/van-hoa-thanh-dong-group',
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    navigate(url);
  };

  const postList = posts?.posts || [];

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filteredPosts = postList.filter((post) =>
    removeAccents(post.title).includes(removeAccents(keyword))
  );

  return (
    <div className="bg-white shadow-lg mb-3 career-opportunities px-md-5">
      <h1 className="text-center default-box-title m-0">CƠ HỘI NGHỀ NGHIỆP</h1>

      <form onSubmit={(e) => e.preventDefault()} id="search-form">
        <input
          type="text"
          name="keyword"
          placeholder="Tìm kiếm: kinh doanh, kế toán,..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <button type="submit" className="btn-search">
          <i className="fas fa-search icon icon-search"></i>
        </button>
      </form>

      <div className="content" id="content">
        <table>
          <thead>
            <tr>
              <th>Vị trí tuyển dụng</th>
              <th className="hide-on-mobile">Ngày đăng</th>
              <th className="hide-on-mobile"></th>
            </tr>
          </thead>
          <tbody>
            {filteredPosts !== 0 ? (
              filteredPosts.map((post, index) => (
                <tr key={index}>
                  <td>
                    <Link
                      className="text-black"
                      to={`/${post.topics[0].slug}/${post.slug}`}
                    >
                      <h4>{post.title}</h4>
                      <p className="show-on-mobile">
                        {formatDate(post.published_at)}
                      </p>
                    </Link>
                  </td>
                  <td className="hide-on-mobile">
                    {formatDate(post.published_at)}
                  </td>
                  <td className="hide-on-mobile detail">
                    <button
                      onClick={() =>
                        handleDetail(`/${post.topics[0].slug}/${post.slug}`)
                      }
                    >
                      Xem chi tiết
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>Không tìm thấy bài viết nào.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        onTop={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        setPage={setPageIndex}
        totalPages={posts.totalPages}
        currentPage={posts.currentPage}
      />
    </div>
  );
};

export default CareerOpportunities;
